export const enum Role {
  ADMIN = 'ADMIN',
  MAINTENANCE = 'MAINTENANCE',
  SALES = 'SALES',
}

export interface AccountStorageValues {
  userName?: string;
  token?: string;
  role?: string;
  companyId?: number;
}

const KEY_USERNAME = 'userName';
const KEY_TOKEN = 'userToken';
const KEY_ROLE = 'userRole';
const KEY_SELECTED_COMPANY_ID = 'selectedCompanyId';

class AccountProvider {

  public clearAccountStorage() {
    localStorage.removeItem(KEY_USERNAME);
    localStorage.removeItem(KEY_TOKEN);
    localStorage.removeItem(KEY_ROLE);
    localStorage.removeItem(KEY_SELECTED_COMPANY_ID);
    sessionStorage.removeItem(KEY_SELECTED_COMPANY_ID);
  }

  public updateAccountStorage(values: AccountStorageValues) {
    localStorage.setItem(KEY_USERNAME, values.userName!!);
    localStorage.setItem(KEY_TOKEN, values.token!!);
    localStorage.setItem(KEY_ROLE, values.role!!);
    this.setSelectedCompanyId(String(values.companyId!!));
  }

  public getAccountStorage(): AccountStorageValues {
    return {
      userName: localStorage.getItem(KEY_USERNAME) || undefined,
      token: localStorage.getItem(KEY_TOKEN) || undefined,
      role: localStorage.getItem(KEY_ROLE) || undefined,
    };
  }

  public getUserName(): string | null {
    return localStorage.getItem(KEY_USERNAME) || null;
  }

  public getSelectedCompanyId(): string | undefined {
    let companyId = sessionStorage.getItem(KEY_SELECTED_COMPANY_ID);

    if (!companyId) {
      companyId = localStorage.getItem(KEY_SELECTED_COMPANY_ID);
      if (companyId) {
        sessionStorage.setItem(KEY_SELECTED_COMPANY_ID, companyId);
      }
    }

    return companyId || undefined;
  }

  public setSelectedCompanyId(companyId: string) {
    sessionStorage.setItem(KEY_SELECTED_COMPANY_ID, companyId);
    localStorage.setItem(KEY_SELECTED_COMPANY_ID, companyId);
  }

  public isLoggedIn(): boolean {
    const account = this.getAccountStorage();
    return account.token !== undefined && account.token.length > 0;
  }

  public getRole(): Role | undefined {
    const role = this.getAccountStorage().role;
    if (role === "ADMIN") {
      return Role.ADMIN;
    } else if (role === "MAINTENANCE") {
      return Role.MAINTENANCE;
    } else if (role === "SALES") {
      return Role.SALES;
    } else {
      return undefined;
    }
  }

  public isAdmin(): boolean {
    return this.getRole() === Role.ADMIN;
  }

  public isMaintenance(): boolean {
    return this.getRole() === Role.MAINTENANCE;
  }

  public isSales(): boolean {
    return this.getRole() === Role.SALES;
  }
}

export default new AccountProvider();



// WEBPACK FOOTER //
// ./src/account/AccountProvider.tsx